import { QuerySpaceGroupPermissionRepository, UpdateSpaceGroupPermissionRepository } from './services/space-group-permission-repository.interface';
import { GroupPermissionRepositoryImpl } from './repository/space-group-permission-repository';
import { SpaceGroupPermissionServiceImpl } from './services/space-group-permission-service';
import { UpdateSpaceGroupPermissionService, QuerySpaceGroupPermissionService } from './services/space-group-permission-service.interface';
import { ApiUpdateSpaceGroupPermissions, ApiQuerySpaceGroupPermissions } from '@/infrastructure/api-functions/api-space-group-permission.interface';
import { SpaceApiServiceImpl } from '@/infrastructure/api-functions/space-api-service';
export function spaceGroupPermissionModule(bind) {
    bind(UpdateSpaceGroupPermissionService).to(SpaceGroupPermissionServiceImpl);
    bind(QuerySpaceGroupPermissionService).to(SpaceGroupPermissionServiceImpl);
    bind(UpdateSpaceGroupPermissionRepository).to(GroupPermissionRepositoryImpl);
    bind(QuerySpaceGroupPermissionRepository).to(GroupPermissionRepositoryImpl);
    bind(ApiUpdateSpaceGroupPermissions).to(SpaceApiServiceImpl);
    bind(ApiQuerySpaceGroupPermissions).to(SpaceApiServiceImpl);
}
